module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-report/home-report.component.sass
// module id = ./src/app/modules/home/components/home-report/home-report.component.sass
// module chunks = main